import { Deserializable } from '../protocols/deserializable';
import { BaseType } from '../base/base-type';
import { BankAccount } from '../../views/banking/models/bank-account';
import { PaylineAccount } from '../../views/banking/models/payline-account';
import { PaymentMethodType } from '../shared/payment-method-type';
import { PaymentMethodTypeIdEnum } from '../enum/shared/payment-method-type-id.enum';
import { SubmissionAttachment } from './submission-attachment';
import { AnnuityGuaranteePeriodType } from '../shared/annuity-guarantee-period-type';
import { MonthlyPensionJurisdictionDetail } from './monthly-pension-jurisdiction-detail';
import { MonthlyPensionSpousalWaiver } from './monthly-pension-spousal-waiver';
import { GoverningJurisdictionType } from '../employers/employer-history/types/governing-jurisdiction-type';
import { GoverningJurisdictionTypeId } from '../enum/shared/governing-jurisdiction-type-id';

export class MonthlyPensionSetupSubmissionData implements Deserializable {
  public id!: string;
  public annuityTypeId!: number;
  public annuityType!: BaseType;
  public annuityGuaranteePeriodId!: number;
  public annuityGuaranteePeriod!: AnnuityGuaranteePeriodType | null;
  public phasedRetirement!: boolean;
  public estimatedMonthlyBenefit!: number;
  public estimatedSurvivorBenefit!: number | null;
  public estimatedPurchasePrice!: number;
  public estimatedConversionRate!: number;
  public effectiveDate!: string;
  public paymentMethodId!: PaymentMethodTypeIdEnum | null;
  public paymentMethod!: PaymentMethodType | null;
  public bankAccountId!: number | null;
  public bankAccount!: BankAccount | null;
  public paylineAccountId!: number | null;
  public paylineAccount!: PaylineAccount | null;
  public jointPensionerId!: number | null;
  public jointPensionerName!: string | null;
  public attachments!: SubmissionAttachment[];
  public jurisdictionDetails!: MonthlyPensionJurisdictionDetail[];
  public governingJurisdictionOverrideId!: GoverningJurisdictionTypeId | null;
  public governingJurisdictionOverride!: GoverningJurisdictionType | null;
  public spousalWaivers!: MonthlyPensionSpousalWaiver[];

  public onDeserialize() {
    const Deserialize = window.injector.Deserialize;
    if (this.annuityType) {
      this.annuityType = Deserialize.instanceOf(BaseType, this.annuityType);
    }
    if (this.annuityGuaranteePeriod) {
      this.annuityGuaranteePeriod = Deserialize.instanceOf(AnnuityGuaranteePeriodType, this.annuityGuaranteePeriod);
    }
    if (this.paymentMethod) {
      this.paymentMethod = Deserialize.instanceOf(PaymentMethodType, this.paymentMethod);
    }
    if (this.bankAccount) {
      this.bankAccount = Deserialize.instanceOf(BankAccount, this.bankAccount);
    }
    if (this.paylineAccount) {
      this.paylineAccount = Deserialize.instanceOf(PaylineAccount, this.paylineAccount);
    }
    if (this.attachments) {
      this.attachments = Deserialize.arrayOf(SubmissionAttachment, this.attachments);
    }
    if (this.jurisdictionDetails) {
      this.jurisdictionDetails = Deserialize.arrayOf(MonthlyPensionJurisdictionDetail, this.jurisdictionDetails);
    }
    if (this.governingJurisdictionOverride) {
      this.governingJurisdictionOverride = Deserialize.instanceOf(
        GoverningJurisdictionType,
        this.governingJurisdictionOverride
      );
    }
    if (this.spousalWaivers) {
      this.spousalWaivers = Deserialize.arrayOf(MonthlyPensionSpousalWaiver, this.spousalWaivers);
    }
  }
}
